export const priceStringToCents = (
  price: string | null | undefined
): number | null => {
  if (!price) {
    return null
  }

  const numberValue = parseFloat(price)

  if (isNaN(numberValue)) {
    return null
  }

  return Math.round(numberValue * 100)
}

export const centsToPriceString = (price: number): string =>
  (price / 100).toString()
